dmx.bs4toast = {

  defaults: {
    iconType: 'image',
    position: 'top',
    align: 'right',
    offsetX: 15,
    offsetY: 15,
    zIndex: 10000,
    minWidth: 240,
    maxWidth: 350,
    animation: true,
    autohide: true,
    closable: true,
    delay: 5000,
  },

  container: null,

  setup (options) {
    options = Object.assign(dmx.bs4toast.defaults, options);

    if (!dmx.bs4toast.container) {
      dmx.bs4toast.container = document.createElement('div');
      document.body.appendChild(dmx.bs4toast.container);
    }

    const container = dmx.bs4toast.container;
    container.removeAttribute('style');

    container.style.setProperty('position', 'fixed');
    container.style.setProperty('z-index', options.zIndex);
    container.style.setProperty(options.align, options.offsetX + 'px');
    container.style.setProperty(options.position, options.offsetY + 'px');
    if (options.maxWidth) {
      container.style.setProperty('max-width', options.maxWidth + 'px');
    }
  },

  clear () {
    if (dmx.bs4toast.container) {
      dmx.bs4toast.container.textContent = '';
    }
  },

  show (options) {
    options = Object.assign({}, dmx.bs4toast.defaults, options);

    if (!dmx.bs4toast.container) {
      dmx.bs4toast.setup();
    }

    const node = dmx.bs4toast.create(options);
    dmx.bs4toast.container.appendChild(node);

    $(node)
      .toast(options)
      .toast('show')
      .on('hidden.bs.toast', () => {
        dmx.bs4toast.container.removeChild(node);
      });
  },

  create (options) {
    const node = document.createElement('div');
    node.className = 'toast';
    node.setAttribute('role', 'alert');
    node.setAttribute('aria-live', 'assertive');
    node.setAttribute('aria-atomic', 'true');
    node.setAttribute('data-delay', options.delay);

    if (options.minWidth) {
      node.style.setProperty('min-width', options.minWidth + 'px');
    }

    if (options.icon || options.title || options.subtitle || options.closable) {
      const header = document.createElement('div');
      header.className = 'toast-header';

      if (options.icon) {
        const isImageFile = (icon) => /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(icon);

        if (isImageFile(options.icon)) {
          header.innerHTML = `<img src="${options.icon}" height="20" class="rounded mr-2" alt="${options.alt || ''}">`;
        } else {
          header.innerHTML = `<i class="${options.icon} mr-2"></i>`;
        }
      }

      if (options.title || options.subtitle || options.closable) {
        const strong = document.createElement('strong');
        strong.className = 'mr-auto';
        strong.textContent = options.title || '';
        
        header.appendChild(strong);
      }

      if (options.subtitle) {
        const small = document.createElement('small');
        small.className = 'text-muted';
        small.textContent = options.subtitle;

        header.appendChild(small);
      }

      if (options.closable) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ml-2 mb-1 close';
        button.setAttribute('data-dismiss', 'toast');
        button.setAttribute('aria-label', 'Close');
        button.innerHTML = '<span aria-hidden="true">&times;</span>';

        header.appendChild(button);
      }

      node.appendChild(header);
    }

    if (options.message) {
      const body = document.createElement('div');
      body.className = 'toast-body';
      if (options.useHTML) {
        body.innerHTML = options.message;
      } else {
        body.textContent = options.message;
      }

      node.appendChild(body);
    }
    
    return node;
  },
};
